import { h } from 'preact';

export default props => (
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path d="M12.5 7H5C3.62 7 2.5 8.12 2.5 9.5C2.5 10.88 3.62 12 5 12H9" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
		<path d="M10.5 5L12.5 7L10.5 9" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
	</svg>
);
